import { useEffect } from "react";
import { DadosEspacoDisco } from "./_components/DadosEspacoDisco";
import { DadosSyncAutomatico } from "./_components/DadosSyncAutomatico";
import { DadosSyncMunicipio } from "./_components/DadosSyncMunicipio";
import { MenuCard } from "./_components/MenuCard";

export function Inicio() {
  useEffect(() => {
    document.title = "Inspeção Mobile - Início";
  }, []);

  return (
    <>
      <MenuCard />

      <DadosSyncMunicipio />

      <DadosSyncAutomatico />

      <DadosEspacoDisco />
    </>
  );
}
